import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './vuetify';
import GlobalService, {
	AppSettings,
	GlobalSymbols,
	INotificationService,
	NotificationSymbols,
	Initializer,
} from 'web-platform-help-desk-core-frontend-ui';
import VueTheMask from 'vue-the-mask';
import UserIdentity from 'web-platform-help-desk-core-frontend-ui/src/Identity/user-identity';
import { ModuleType } from 'web-platform-help-desk-core-frontend-ui/src/Global/module-type';

Vue.use(VueTheMask);

const settings = new AppSettings();

//settings.SetModuleType(ModuleType.Base);
//settings.SetHelpAddress('https://localhost:44383');

//settings.SetModuleType(ModuleType.Base);
//settings.SetHelpAddress('https://help-desk-test.moipass.ru');

//settings.SetModuleType(ModuleType.Elbrus);
//settings.SetHelpAddress('https://elbrus-help.moipass.ru');

//settings.SetModuleType(ModuleType.Holland);
//settings.SetHelpAddress('https://holland-help-desk-test.moipass.ru');

//settings.SetModuleType(ModuleType.PrimorskyOceanarium);
//settings.SetHelpAddress('https://primocean-help.moipass.ru');

//settings.SetModuleType(ModuleType.Holland);
//settings.SetHelpAddress('https://nhi-help.moipass.ru');

//settings.SetModuleType(ModuleType.Gum);
//settings.SetHelpAddress('https://gum-help.moipass.ru');

//settings.SetModuleType(ModuleType.Vdnh);
//settings.SetHelpAddress('https://vdnh-help.moipass.ru');

//settings.SetModuleType(ModuleType.AkvaLushniki);
//settings.SetHelpAddress('https://help-desk-aquacomplex.moipass.ru');

settings.SetModuleType(ModuleType.AkvaLushniki);
settings.SetHelpAddress('https://aqua-storno.luzhniki.ru');

//settings.SetModuleType(ModuleType.BobrLog);
//settings.SetHelpAddress('https://bobrovylog-help.moipass.ru');

//settings.SetModuleType(ModuleType.LuzhnikiSber);
//settings.SetHelpAddress('https://luzhniki-sber-help.moipass.ru');

//settings.SetModuleType(ModuleType.LuzhnikiKatok);
//settings.SetHelpAddress('https://luzhniki-katok.moipass.ru');

//settings.SetModuleType(ModuleType.Buhtagold);
//settings.SetHelpAddress('https://buhtagold.moipass.ru');

settings.SetPhoneFieldEnabled(AppSettings.ModuleType != ModuleType.Holland && AppSettings.ModuleType != ModuleType.Base);
settings.SetTelegramBotEnabled(false);

GlobalService.SetSettings<AppSettings>(settings);

if (settings.IsDevVersion) {
	Vue.config.productionTip = false;
	Vue.config.devtools = true;
} else {
	Vue.config.productionTip = true;
	Vue.config.devtools = false;
}

let managerSettings = {
	authority: `${settings.IdentityServerUrl}identity`,
	client_id: settings.IsDevVersion ? '1368645b-7686-4270-8e0a-857e227b950c' : '018f81aa-9d12-40f7-828d-716f5f0cb414',
	redirect_uri: window.location.origin + '/callback.html',
	response_type: 'id_token token',
	scope: 'openid profile all_claims useraccapi adminapi',
	post_logout_redirect_uri: window.location.origin + '/',
	silent_redirect_uri: window.location.origin + '/silent-renew.html',
	accessTokenExpiringNotificationTime: 60,
	automaticSilentRenew: true,
	filterProtocolClaims: true,
	loadUserInfo: true,
	monitorSession: false,
};

const globalService = new GlobalService();
const context = new UserIdentity(managerSettings);
context.Initialize(settings, globalService);
globalService.LoadConfiguration(context);

// Initializer.InitializeAsync(globalService);

router.beforeEach(async (to, from, next) => {
	const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
	if (requiresAuth) {
		if (!context.CurrentIdentity.IsAuthentificated) {
			context.SignIn();
		} else next();
	} else {
		next();
	}
});

new Vue({
	router,
	vuetify,
	render: (h) => h(App),
	provide: {
		[GlobalSymbols.GlobalService]: globalService,
	},
}).$mount('#app');

function _errorEventHandler(errorMsg: string, url: string, lineNumber: string): void {
	let notificationService = globalService.Get<INotificationService>(NotificationSymbols.NotificationService);
	notificationService.Error('������', errorMsg);
	console.log(`error: ${errorMsg}, url: ${url}, lineNumber: ${lineNumber}`);
}

const _global = (window || globalThis) as any;
_global.onerror = _errorEventHandler;
